// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .item-wrapper[data-v-cea3178a]:hover{background-color:#f3f5f6}.item-wrapper .title[data-v-cea3178a]{font-size:.9rem}.item-wrapper .fixed-field-value[data-v-cea3178a]{font-size:.8rem;color:#6e8491}[dir] .item-wrapper .fixed-field-value[data-v-cea3178a]{margin:0}", ""]);
// Exports
module.exports = exports;
